import {ServiceApi} from "./serviceApi";
import {AccessToken} from "../auth/auth0";

var _getProfileFromAccessToken = function (accessToken, callback) {
    var decodedProfile = accessToken.decode();
    return callback(null, {
        user_id: decodedProfile.sub,
        picture: null,
        name: "Guest",
        given_name: "Guest",
        email: null,
        created_at: new Date(decodedProfile.iat * 1000)
    });
};

export default class EventSecretRefreshToken {

    constructor(private serviceApi: ServiceApi, private eventId: string, private eventPassword: string) {

    }

    generateIdToken(srcClientId, dstClientId, callback) {
        this.serviceApi.createEventPermitWithEventPassword(this.eventId, this.eventPassword)
            .then(tokenObj => {
                var accessToken = new AccessToken(dstClientId, tokenObj);
                accessToken.getInfo = _getProfileFromAccessToken.bind(null, accessToken);
                return accessToken;
            })
            .then(callback.bind(null, null))
            .catch(callback.bind(null));
    }

    token() {
        return JSON.stringify({eventId : this.eventId, eventPassword: this.eventPassword})
    }
}
